export default {
    "name": "DashboardReportMetadataQuery",
    "kind": "HoudiniQuery",
    "hash": "bcaeae01421fbfbbec500150e33128d2d4e6569834e38b1cef1a23e1594ad233",

    "raw": `query DashboardReportMetadataQuery($dashboardReportId: Int!, $chartArgs: DashboardReportChartsArgs) {
  dashboardReport(id: $dashboardReportId) {
    dashboardReportId: id
    title
    ownerId
    autoRefreshInterval
    name
    shareId
    shareType
    ownerId
    parameterValues {
      ... on DashboardReportDateRangeParameter {
        name
        type
        title
        default
        value
        dates {
          from
          to
        }
      }
      ... on DashboardReportDateParameter {
        name
        type
        title
        default
        value
      }
      ... on DashboardReportSelectionParameter {
        name
        type
        title
        default
        value
        optionList {
          id
          name
          rawSql
          fromQuery
        }
      }
      ... on DashboardReportSessionParameter {
        name
        type
        title
        default
        value
      }
      ... on DashboardReportSiteSelectionParameter {
        name
        type
        title
        default
        value
        permission
        optionList {
          id
          name
          fromQuery
        }
      }
      __typename
    }
    charts(args: $chartArgs) {
      chartId: id
      name
      title
      rank
      json: jsonCombined
      supertype
      showChart: display
      id
    }
    id
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "dashboardReport": {
                "type": "DashboardReport",
                "keyRaw": "dashboardReport(id: $dashboardReportId)",
                "nullable": true,

                "selection": {
                    "fields": {
                        "dashboardReportId": {
                            "type": "Int",
                            "keyRaw": "dashboardReportId",
                            "visible": true
                        },

                        "title": {
                            "type": "String",
                            "keyRaw": "title",
                            "visible": true
                        },

                        "ownerId": {
                            "type": "Int",
                            "keyRaw": "ownerId",
                            "nullable": true,
                            "visible": true
                        },

                        "autoRefreshInterval": {
                            "type": "Float",
                            "keyRaw": "autoRefreshInterval",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        },

                        "shareId": {
                            "type": "Int",
                            "keyRaw": "shareId",
                            "nullable": true,
                            "visible": true
                        },

                        "shareType": {
                            "type": "DashboardReportShareType",
                            "keyRaw": "shareType",
                            "nullable": true,
                            "visible": true
                        },

                        "parameterValues": {
                            "type": "DashboardReportParameter",
                            "keyRaw": "parameterValues",

                            "selection": {
                                "abstractFields": {
                                    "fields": {
                                        "DashboardReportDateRangeParameter": {
                                            "name": {
                                                "type": "String",
                                                "keyRaw": "name",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "type": {
                                                "type": "DashboardReportParameterType",
                                                "keyRaw": "type",
                                                "visible": true
                                            },

                                            "title": {
                                                "type": "String",
                                                "keyRaw": "title",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "default": {
                                                "type": "String",
                                                "keyRaw": "default",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "dates": {
                                                "type": "DashboardReportDateRangeParameterDates",
                                                "keyRaw": "dates",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "from": {
                                                            "type": "String",
                                                            "keyRaw": "from",
                                                            "visible": true
                                                        },

                                                        "to": {
                                                            "type": "String",
                                                            "keyRaw": "to",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "__typename": {
                                                "type": "String",
                                                "keyRaw": "__typename",
                                                "visible": true
                                            }
                                        },

                                        "DashboardReportDateParameter": {
                                            "name": {
                                                "type": "String",
                                                "keyRaw": "name",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "type": {
                                                "type": "DashboardReportParameterType",
                                                "keyRaw": "type",
                                                "visible": true
                                            },

                                            "title": {
                                                "type": "String",
                                                "keyRaw": "title",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "default": {
                                                "type": "String",
                                                "keyRaw": "default",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "__typename": {
                                                "type": "String",
                                                "keyRaw": "__typename",
                                                "visible": true
                                            }
                                        },

                                        "DashboardReportSelectionParameter": {
                                            "name": {
                                                "type": "String",
                                                "keyRaw": "name",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "type": {
                                                "type": "DashboardReportParameterType",
                                                "keyRaw": "type",
                                                "visible": true
                                            },

                                            "title": {
                                                "type": "String",
                                                "keyRaw": "title",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "default": {
                                                "type": "String",
                                                "keyRaw": "default",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "optionList": {
                                                "type": "OptionListEntry",
                                                "keyRaw": "optionList",

                                                "selection": {
                                                    "fields": {
                                                        "id": {
                                                            "type": "String",
                                                            "keyRaw": "id",
                                                            "visible": true,
                                                            "nullable": true
                                                        },

                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "rawSql": {
                                                            "type": "Boolean",
                                                            "keyRaw": "rawSql",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "fromQuery": {
                                                            "type": "Boolean",
                                                            "keyRaw": "fromQuery",
                                                            "nullable": true,
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "__typename": {
                                                "type": "String",
                                                "keyRaw": "__typename",
                                                "visible": true
                                            }
                                        },

                                        "DashboardReportSessionParameter": {
                                            "name": {
                                                "type": "String",
                                                "keyRaw": "name",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "type": {
                                                "type": "DashboardReportParameterType",
                                                "keyRaw": "type",
                                                "visible": true
                                            },

                                            "title": {
                                                "type": "String",
                                                "keyRaw": "title",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "default": {
                                                "type": "String",
                                                "keyRaw": "default",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "__typename": {
                                                "type": "String",
                                                "keyRaw": "__typename",
                                                "visible": true
                                            }
                                        },

                                        "DashboardReportSiteSelectionParameter": {
                                            "name": {
                                                "type": "String",
                                                "keyRaw": "name",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "type": {
                                                "type": "DashboardReportParameterType",
                                                "keyRaw": "type",
                                                "visible": true
                                            },

                                            "title": {
                                                "type": "String",
                                                "keyRaw": "title",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "default": {
                                                "type": "String",
                                                "keyRaw": "default",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "permission": {
                                                "type": "String",
                                                "keyRaw": "permission",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "optionList": {
                                                "type": "OptionListEntry",
                                                "keyRaw": "optionList",

                                                "selection": {
                                                    "fields": {
                                                        "id": {
                                                            "type": "String",
                                                            "keyRaw": "id",
                                                            "visible": true,
                                                            "nullable": true
                                                        },

                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "fromQuery": {
                                                            "type": "Boolean",
                                                            "keyRaw": "fromQuery",
                                                            "nullable": true,
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "__typename": {
                                                "type": "String",
                                                "keyRaw": "__typename",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "typeMap": {}
                                },

                                "fields": {
                                    "__typename": {
                                        "type": "String",
                                        "keyRaw": "__typename",
                                        "visible": true
                                    }
                                }
                            },

                            "abstract": true,
                            "visible": true
                        },

                        "charts": {
                            "type": "DashboardChart",
                            "keyRaw": "charts(args: $chartArgs)",

                            "selection": {
                                "fields": {
                                    "chartId": {
                                        "type": "Int",
                                        "keyRaw": "chartId",
                                        "visible": true
                                    },

                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "visible": true
                                    },

                                    "title": {
                                        "type": "String",
                                        "keyRaw": "title",
                                        "visible": true
                                    },

                                    "rank": {
                                        "type": "Int",
                                        "keyRaw": "rank",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "json": {
                                        "type": "String",
                                        "keyRaw": "json",
                                        "visible": true
                                    },

                                    "supertype": {
                                        "type": "DashboardChartSupertype",
                                        "keyRaw": "supertype",
                                        "visible": true
                                    },

                                    "showChart": {
                                        "type": "Boolean",
                                        "keyRaw": "showChart",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "Int",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "dashboardReportId": "Int",
            "chartArgs": "DashboardReportChartsArgs"
        },

        "types": {
            "DashboardReportChartsArgs": {
                "hidden": "Boolean",
                "id": "Int",
                "inReport": "Boolean"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=f953d1113949971b298d228a466d06558fc6bfe25065b3d469b69bf718b55a57";